import GlobalCashRegistersHandler from './GlobalCashRegistersHandler'
import getAppConfig from './gql/getAppConfig'
import updateGlobalCR from './gql/updateGlobalCR'
import getAppConfigAdditional from './gql/getAppConfigAdditional'
import { ContentTranslations, VirtualCards, PriceLevels, CashFlow, Tara, Kitchen, SalesGroups, ERP, Export, Settings, ClickAndCollect, CashBook, DeviceUpdate, ProductGroups } from './pages'

export default (t, props) => {
	return ({
		label: t('options_section.sub_sections.cash_register_global'),
		link: 'kasse-global',
		typename: 'AppConfig',
		subsections: [
			{
				name: t('options_section.sub_sections.price_category'),
				link: 'preiskategorie',
				component: PriceLevels,
				updateMutation: updateGlobalCR.priceLevels,
				fields: [ 'maxPriceLevel', 'priceLevelsLinkFA', 'priceLevelsCafeLinkFA', 'isExternCreditClient' ]
			},
			{
				name: t('options_section.sub_sections.sales_groups'),
				link: 'umsatzgruppen',
				component: SalesGroups
			},
			{
				name: t('options_section.sub_sections.statistic_groups'),
				link: 'statistic-groups',
				component: ProductGroups
			},
			{
				name: t('options_section.sub_sections.kitchen_locations'),
				link: 'küchenstandorte',
				component: Kitchen,
				updateMutation: updateGlobalCR.kitchen,
				fields: [{
					fieldName: 'cashRegisterGlobal',
					__typename: 'CashRegisterGlobalParameters',
					children: [{ fieldName: 'kitchenTimeSlots', children: ['timeSlotCode', 'name'], __typename: 'KitchenTimeSlot' }]
				}]
			},
			{
				name: t('options_section.sub_sections.cash_flow'),
				link: 'geldfluss',
				component: CashFlow,
				updateMutation: updateGlobalCR.cashFlow,
				fields: ['creditCards', 'specialProductExpenses', 'innerNameCurrency1', 'innerNameCurrency2', 'innerNameCurrency3', 'outerNameCurrency1', 'outerNameCurrency2', 'outerNameCurrency3',
					{ fieldName: 'cashRegisterGlobal', __typename: 'CashRegisterGlobalParameters', children:
						['pointsSystemName', 'isActivePointsSystem', 'pointsToActivate', 'pointsProduct', 'pointsCategory', 'useForCreditCustomerPayments']
					}
				],
				refetchQueries: [{ query: getAppConfigAdditional }]
			},
			{
				name: t('options_section.strings.cash_book'),
				link: 'kassenbuch',
				component: CashBook
			},
			{
				name: t('options_section.sub_sections.scales'),
				link: 'waage',
				component: Tara,
				updateMutation: updateGlobalCR.tara,
				fields: ['taraName']
			},
			{
				name: t('options_section.sub_sections.settings'),
				link: 'einstellungen',
				component: Settings
			},
			/*,
			{
				name: t('options_section.sub_sections.statistic_groups'),
				link: 'statistik Gruppen',
				hidden: true,
				component: () => 'Statistik Gruppen'
			}*/
			{
				name: t('options_section.sub_sections.order'),
				link: 'erp',
				component: ERP
			},
			 {
				name: t('options_section.sub_sections.export'),
				link: 'export',
				component: Export,
				updateMutation: updateGlobalCR.updateAppConfigAdditional,
				fields: [{
					fieldName: 'cashRegisterGlobal', __typename: 'CashRegisterGlobalParameters',
					children: ['portosIntegrationKey', 'e2nIntegrationActive', 'e2nReportingActive']
				}, {
					fieldName: 'appConfigAdditional', __typename: 'AppConfigAdditional',
					children: ['bexioApiToken', 'brotZeitApiToken', 'brotzeitSubdomain', 'pentacodeEnabled', 'isMirusExportEnabled']
				}]
			},
			{
				name: t('options_section.sub_sections.virtual_cards'),
				link: 'virtualCard',
				component: VirtualCards
			},
			{
				name: 'Click & Collect',
				link: 'click-collect',
				component: ClickAndCollect
			},
			{
				name: t('options_section.sub_sections.update'),
				link: 'update',
				component: DeviceUpdate
			},
			{
				name: t('common.strings.contentTranslations'),
				link: 'content-translations',
				component: ContentTranslations
			}
		],
		itemQuery: getAppConfig,
		handler: GlobalCashRegistersHandler
	})
}
